/**
 * Client-side feature flags.
 *
 * PURCHASING_ENABLED — when false, every UI affordance that starts a purchase
 * is hidden: flower/cleaning service orders, care subscriptions, medallion
 * orders, and subscription reactivation. Disabled 2026-08-07: Pontis can no
 * longer fulfil these services.
 *
 * This only hides the UI. The authoritative switch is the matching constant in
 * supabase/functions/_shared/features.ts, which refuses the request server-side
 * — necessary because create-service-checkout accepts guest checkout and can be
 * called without going through this app at all. Flip both together.
 *
 * Memorials, photos, stories, collaborators, and every other non-commercial
 * feature are unaffected by this flag.
 */
export const PURCHASING_ENABLED = false
